// @flow
import React from 'react';
import ProfileEmptyState from 'app/common/react/components/profile/ProfileEmptyState/ProfileEmptyState';
import ProfileEmptyStateText from 'app/common/react/components/profile/ProfileEmptyState/ProfileEmptyStateText';
import TimeSpent from 'app/common/lib/react/TimeSpent';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';
import { Box } from 'gestalt';
import { UserProfilePinGrid } from 'app/common/react/components/profile/UserProfilePinGrid/UserProfilePinGrid';
import type { Category, Filter } from 'app/common/react/components/profile/ProfileSearch/types';

type Props = {|
  isOwnProfile: boolean,
  searchResource: {
    data: {
      categories: Array<Category>,
      filter: Filter,
      results: Array<Object>,
    },
    fetchMore: () => void,
    isFetching: boolean,
    isLoaded: boolean,
    refreshData: () => void,
  },
  user: ProfileUser,
  viewer: Viewer,
|};

export default function ProfileSearchPins(props: Props) {
  const { isOwnProfile, searchResource, user, viewer } = props;
  const timeSpentViewParam = isOwnProfile
    ? PCONST.thrift.ViewParameterType.USER_SELF
    : PCONST.thrift.ViewParameterType.USER_OTHERS;

  const emptyState = (
    <ProfileEmptyState>
      <ProfileEmptyStateText subject="search" surface="shop" user={user} viewer={viewer} />
    </ProfileEmptyState>
  );

  const pinResource = {
    data: searchResource.data ? searchResource.data.results : [],
    fetchMore: searchResource.fetchMore,
    isFetching: searchResource.isFetching,
    isLoaded: searchResource.isLoaded,
    refreshData: searchResource.refreshData,
  };

  return (
    <Box>
      <TimeSpent
        view={PCONST.thrift.ViewType.USER}
        viewParameter={timeSpentViewParam}
        component={PCONST.thrift.ComponentType.USER_STOREFRONT}
      >
        <UserProfilePinGrid
          emptyState={emptyState}
          isOverview={false}
          isOwnProfile={isOwnProfile}
          pins={pinResource}
          user={user}
          username={user.username}
          viewer={viewer}
        />
      </TimeSpent>
    </Box>
  );
}
